<section class="receipt-form-wrapper">
  <div class="box-container">
    <!-- topic -->
    <div class="partner-topic">
      <!-- desktop heading  -->
      <div
        class="partner-topic__heading partner-topic__heading--desktop color-gray"
        [innerHtml]="'RECEIPT.SECTION_FEATURE.HEADING' | translate"
      ></div>

      <!-- tablet heading  -->
      <div
        class="partner-topic__heading partner-topic__heading--tablet color-gray"
        [innerHtml]="'RECEIPT.SECTION_FEATURE.HEADING_TABLET' | translate"
      ></div>

      <!-- mobile heading  -->
      <div
        class="partner-topic__heading partner-topic__heading--mobile color-gray"
        [innerHtml]="'RECEIPT.SECTION_FEATURE.HEADING_MOBILE' | translate"
      ></div>

      <div class="partner-topic__heading-detail">{{ 'RECEIPT.SECTION_FEATURE.DETAIL' | translate }}</div>
    </div>

    <!-- content -->
    <div class="box">
      <!-- 1 -->
      <div class="box__item">
        <picture class="img-desktop">
          <source srcset="{{getImageWebp}}" type="image/webp" />
          <img
            src="{{ getImage }}"
            width="100%"
            loading="lazy"
            class="box__image"
            alt="{{ getAltText }}"
            title="{{ getAltText }}"
          />
        </picture>

        <picture class="img-tablet">
          <source srcset="{{getImageMobileWebp}}" type="image/webp" />
          <img src="{{ getImageMobile }}" width="100%" loading="lazy" class="box__image" alt="{{ getAltText }}" />
        </picture>
      </div>
    </div>
  </div>
</section>
